/**
 * 由于后端时间返回的是秒而不是毫秒，所以乘以1000
 * @param {number} time
 * > number: 后端时间戳
 */
export default function (time) {
  return typeof time === 'number' ? time * 1000 : null
}
